<template>
  <div class="product-gallery-container">
    <ProductCard
      v-for="product in products"
      :key="product.id"
      :product="product"
    />
  </div>
</template>

<script>
import ProductCard from "./ProductCard";
export default {
  name: "product-gallery",
  props: {
    products: { type: Array, default: () => [] }
  },
  components: {
    ProductCard
  }
};
</script>

<style lang="scss" scoped>
.product-gallery-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, 25%);
  height: fit-content;
  width: 100%;
}

@media (max-width: 991px){
  .product-gallery-container {
    grid-template-columns: repeat(auto-fill, 100%);
  }
}
</style>
